import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/", label: "Home", id: "nav-home-link" },
  { to: "/about", label: "About Us", id: "nav-about-link" },
  { to: "/services", label: "Our Services", id: "nav-services-link" },
  { to: "/approach", label: "Our Approach", id: "nav-approach-link" },
  { to: "/case-studies", label: "Case Studies", id: "nav-case-studies-link" },
  { to: "/insights", label: "Insights", id: "nav-insights-link" },
  { to: "/contact", label: "Contact Us", id: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/85 backdrop-blur-xl">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:bg-teal focus:text-white focus:px-4 focus:py-2 focus:font-semibold">
        Skip to main content
      </a>
      <nav className="container-arms flex h-[96px] items-center justify-between" aria-label="Main navigation">
        <Link to="/" aria-label="Advanced Risk Management Solutions — home" data-testid="nav-logo-link">
          <Logo light={false} />
        </Link>
        <ul className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={l.id}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                    isActive ? "bg-teal/10 text-teal" : "text-slate-600 hover:text-navy hover:bg-slate-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
          <li>
            <Link
              to="/contact#enquiry-form"
              data-testid="nav-enquire-cta"
              className="ml-3 rounded-full bg-teal px-5 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:scale-[1.03] hover:bg-navy"
            >
              Make an enquiry
            </Link>
          </li>
        </ul>
        <button
          className="lg:hidden rounded-md p-2 text-navy"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          <ul className="container-arms flex flex-col gap-1 py-4">
            {LINKS.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`${l.id}-mobile`}
                  className={({ isActive }) =>
                    `block rounded-lg px-4 py-3 text-base font-medium ${isActive ? "bg-teal/10 text-teal" : "text-slate-700"}`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li>
              <Link
                to="/contact#enquiry-form"
                onClick={() => setOpen(false)}
                data-testid="nav-enquire-cta-mobile"
                className="mt-2 block rounded-full bg-teal px-4 py-3 text-center text-base font-bold text-white"
              >
                Make an enquiry
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
